import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class SubCategoryService extends GenericService {
  constructor() {
    super('/sub_categories', axiosInstance);
  }
}

export default new SubCategoryService(); 